// Full-document render of the stearns TempurLoveSocialPage: PageSkeleton (the
// React document shell) wrapping the tempur-love header (rendered only when the
// page sits under a TempurLoveRootPage, like the legacy partial's
// {% if love_root %}) and the existing social-gallery body island.
import React from "react";

import { templates } from "@reactivated";

import { TempurLoveSocialPage as TempurLoveSocialPageBody } from "../apps/tempur-love/TempurLoveSocialPage";
import { PageSkeleton } from "../components/PageSkeleton";
import { TempurLoveHeader } from "../components/TempurLoveHeader";

export const Template = (
    props: templates.TempurLoveSocialPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        {props.love_root && <TempurLoveHeader love_root={props.love_root} />}
        <TempurLoveSocialPageBody
            page_info={props.page_info}
            love_root_info={props.love_root_info}
            initial_ugc_data={props.initial_ugc_data}
            initial_next_url={props.initial_next_url}
        />
    </PageSkeleton>
);
